// A curated list of major international business hubs for the HQ Location
// suggestions dropdown. Not exhaustive — the field still accepts free text,
// this just gives fast suggestions for the most common answers.
export const MAJOR_CITIES: string[] = [
  // North America
  'New York, USA',
  'San Francisco, USA',
  'Los Angeles, USA',
  'Chicago, USA',
  'Austin, USA',
  'Seattle, USA',
  'Boston, USA',
  'Miami, USA',
  'Atlanta, USA',
  'Denver, USA',
  'Dallas, USA',
  'Houston, USA',
  'Washington, D.C., USA',
  'Philadelphia, USA',
  'San Diego, USA',
  'Phoenix, USA',
  'Portland, USA',
  'Toronto, Canada',
  'Vancouver, Canada',
  'Montreal, Canada',
  'Ottawa, Canada',
  'Mexico City, Mexico',
  'Guadalajara, Mexico',

  // South America
  'São Paulo, Brazil',
  'Rio de Janeiro, Brazil',
  'Buenos Aires, Argentina',
  'Santiago, Chile',
  'Bogotá, Colombia',
  'Lima, Peru',
  'Montevideo, Uruguay',
  'Medellín, Colombia',

  // Europe
  'London, United Kingdom',
  'Manchester, United Kingdom',
  'Edinburgh, United Kingdom',
  'Dublin, Ireland',
  'Paris, France',
  'Berlin, Germany',
  'Munich, Germany',
  'Frankfurt, Germany',
  'Hamburg, Germany',
  'Amsterdam, Netherlands',
  'Rotterdam, Netherlands',
  'Brussels, Belgium',
  'Zurich, Switzerland',
  'Geneva, Switzerland',
  'Vienna, Austria',
  'Madrid, Spain',
  'Barcelona, Spain',
  'Lisbon, Portugal',
  'Rome, Italy',
  'Milan, Italy',
  'Stockholm, Sweden',
  'Copenhagen, Denmark',
  'Oslo, Norway',
  'Helsinki, Finland',
  'Warsaw, Poland',
  'Krakow, Poland',
  'Prague, Czech Republic',
  'Budapest, Hungary',
  'Bucharest, Romania',
  'Athens, Greece',
  'Reykjavik, Iceland',
  'Luxembourg City, Luxembourg',
  'Tallinn, Estonia',
  'Vilnius, Lithuania',
  'Riga, Latvia',
  'Kyiv, Ukraine',
  'Moscow, Russia',
  'Istanbul, Turkey',

  // Middle East
  'Dubai, UAE',
  'Abu Dhabi, UAE',
  'Riyadh, Saudi Arabia',
  'Jeddah, Saudi Arabia',
  'Doha, Qatar',
  'Manama, Bahrain',
  'Kuwait City, Kuwait',
  'Tel Aviv, Israel',
  'Jerusalem, Israel',
  'Amman, Jordan',
  'Muscat, Oman',

  // Africa
  'Cairo, Egypt',
  'Lagos, Nigeria',
  'Nairobi, Kenya',
  'Cape Town, South Africa',
  'Johannesburg, South Africa',
  'Casablanca, Morocco',
  'Accra, Ghana',
  'Addis Ababa, Ethiopia',
  'Kigali, Rwanda',
  'Tunis, Tunisia',
  'Lusaka, Zambia',

  // South Asia
  'Mumbai, India',
  'Delhi, India',
  'Bengaluru, India',
  'Hyderabad, India',
  'Chennai, India',
  'Pune, India',
  'Kolkata, India',
  'Ahmedabad, India',
  'Gurugram, India',
  'Noida, India',
  'Karachi, Pakistan',
  'Lahore, Pakistan',
  'Islamabad, Pakistan',
  'Dhaka, Bangladesh',
  'Colombo, Sri Lanka',
  'Kathmandu, Nepal',

  // East Asia
  'Tokyo, Japan',
  'Osaka, Japan',
  'Yokohama, Japan',
  'Seoul, South Korea',
  'Busan, South Korea',
  'Beijing, China',
  'Shanghai, China',
  'Shenzhen, China',
  'Guangzhou, China',
  'Hong Kong SAR',
  'Taipei, Taiwan',
  'Ulaanbaatar, Mongolia',

  // Southeast Asia
  'Singapore, Singapore',
  'Kuala Lumpur, Malaysia',
  'Bangkok, Thailand',
  'Jakarta, Indonesia',
  'Manila, Philippines',
  'Ho Chi Minh City, Vietnam',
  'Hanoi, Vietnam',
  'Phnom Penh, Cambodia',
  'Yangon, Myanmar',

  // Oceania
  'Sydney, Australia',
  'Melbourne, Australia',
  'Brisbane, Australia',
  'Perth, Australia',
  'Auckland, New Zealand',
  'Wellington, New Zealand',
]
